import moment from "moment";
import { getUtcFormat } from "./moscowTime";

const adjustInstalledDateResponse = (time: number): number => {
  const x = getUtcFormat(time * 1000) + " 12:00";
  const r = moment(x, "YYYY-MM-DD HH:mm").local(true).unix();
  return r;
}

export default adjustInstalledDateResponse;